import {useContext, useEffect, useState} from 'react'
import {Flex, Image, Text, Box, Link, useToast} from '@chakra-ui/react'
import Logo from '@assets/svgs/logo.svg'
import {Button, Form, FormProps, Input} from 'antd'
import {CommonColors} from '@utils/CommonStyles'
import {useLocation, useNavigate} from 'react-router-dom'
import {PATH, SCREEN_TRACKING, STATUS_CODE} from '@utils/Const'
import appRequest from '@apis/app'
import {AuthContext} from '@hooks/useAuth'
import {trackingPage} from '@utils'
import Loading from '@components/Loading'
import bgLogin from '@assets/images/bg-login.png'

const LoginPage = () => {
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const toast = useToast()
  const auth = useContext(AuthContext)
  const {entry_point, task_id} = useLocation()?.state || {}

  useEffect(() => {
    trackingPage(SCREEN_TRACKING.LOGIN_PAGE)
  }, [])

  const onFinish: FormProps<any>['onFinish'] = async values => {
    setIsLoading(true)
    const loginData = await appRequest.login(values)
    if (loginData?.data?.status === STATUS_CODE.SUCCESS) {
      auth?.onLogin(loginData)
      trackingPage(SCREEN_TRACKING.LOGIN_PAGE_SUCCESS)
      navigate(PATH.HOME, {replace: true})
    } else {
      toast({
        title: loginData.response?.data?.message || 'Đã có lỗi xảy ra',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    }
    setIsLoading(false)
  }

  return (
    <Flex
      sx={styles.container}
      bgImage={bgLogin}
      bgSize={'cover'}
      bgPosition={'center'}
      bgRepeat={'no-repeat'}>
      {isLoading && <Loading />}
      <Image
        onClick={() => navigate(PATH.HOME, {replace: true})}
        src={Logo}
        w={{base: '300px', md: '400px'}}
        sx={styles.logo}
        cursor={'pointer'}
      />
      <Box sx={styles.form} w={{base: '100%', md: '480px'}}>
        <Flex flexDirection={'column'}>
          <Text sx={styles.title}>Đăng nhập</Text>
          <Form
            name="basic"
            layout={'vertical'}
            autoComplete="off"
            onFinish={onFinish}>
            <Form.Item
              label="Số điện thoại"
              name="phone"
              rules={[
                {required: true, message: 'Số điện thoại không hợp lệ'},
                {min: 10, max: 12, message: 'Số điện thoại không hợp lệ'},
                {pattern: /^[0-9]+$/, message: 'Số điện thoại không hợp lệ'},
              ]}
              validateTrigger="onChange"
              validateFirst>
              <Input />
            </Form.Item>

            <Form.Item
              label="Mật khẩu"
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Vui lòng nhập mật khẩu',
                },
              ]}>
              <Input.Password />
            </Form.Item>
            <Flex justifyContent={'flex-end'}>
              <Link onClick={() => navigate(PATH.FORGET_PASSWORD)}>
                Quên mật khẩu?
              </Link>
            </Flex>
            <Form.Item style={{marginTop: '30px'}}>
              <Button htmlType="submit" type="primary" style={styles.button}>
                Đăng nhập
              </Button>
            </Form.Item>
            <Text sx={styles.textRegister}>
              Tôi chưa có tài khoản?
              <Link
                color="#1890FF"
                onClick={() =>
                  navigate(PATH.REGISTER, {state: {entry_point, task_id}})
                }
                ml={'6px'}>
                Đăng ký miễn phí ngay
              </Link>
            </Text>
          </Form>
        </Flex>
      </Box>
    </Flex>
  )
}

const styles = {
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    flexDirection: 'column',
    backgroundColor: CommonColors.blue1,
  },
  form: {
    flexDirection: 'column',
    backgroundColor: CommonColors.white,
    padding: 8,
    alignItems: 'center',
    borderRadius: '24px',
    justifyContent: 'center',
  },
  logo: {
    marginBottom: '48px',
  },
  button: {
    width: '100%',
    borderRadius: '12px',
    backgroundColor: CommonColors.blue2,
    height: '46px',
  },
  textRegister: {
    fontWeight: 600,
    fontSize: '14px',
    textAlign: 'center',
  },
  title: {
    fontWeight: 600,
    fontSize: '24px',
    textAlign: 'center',
  },
}

export default LoginPage
